import { html } from 'lit';

// prettier-ignore
export const calloutTooltip = html`<svg width="170" height="106" viewBox="0 0 170 106" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3479_144688)">
<rect width="170" height="106" fill="white"/>
<text fill="#8E8D91" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="8" y="16.6364">Highlight important notes.</tspan></text>
<path d="M8 32.1816C8 29.3199 10.3199 27 13.1816 27H489.892C492.754 27 495.073 29.3199 495.073 32.1816V90.8403C495.073 93.702 492.754 96.0219 489.892 96.0219H13.1816C10.3199 96.0219 8 93.702 8 90.8403V32.1816Z" fill="#EEFFFD"/>
<g clip-path="url(#clip1_3479_144688)">
<g clip-path="url(#clip2_3479_144688)">
<text fill="black" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="15" font-weight="500" letter-spacing="0em"><tspan x="14.7494" y="50.1658">&#x1f44b;</tspan></text>
</g>
</g>
<text fill="#141414" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="44.9541" y="49.4196">A storyboard is a visual representation of a story, typically presented in the form of sequential </tspan><tspan x="44.9541" y="64.9645">panels. Each panel features illustrations or images accompanied by notes describing key </tspan><tspan x="44.9541" y="80.5094">scenes or shots, including details of action and dialogue. </tspan></text>
</g>
<defs>
<clipPath id="clip0_3479_144688">
<rect width="170" height="106" fill="white"/>
</clipPath>
<clipPath id="clip1_3479_144688">
<rect width="24" height="30.477" fill="white" transform="translate(14.477 30.2388)"/>
</clipPath>
<clipPath id="clip2_3479_144688">
<rect x="14.477" y="36.7158" width="24" height="24" rx="1.94311" fill="white"/>
</clipPath>
</defs>
</svg>
`;
